import React, { Component } from 'react';

class Ball extends Component {

  render() {
    const { ball, balls, getCount, breakNumber, frameNumber, player } = this.props;
    const count = getCount(balls, ball.id);


    return (
      <div className="d-flex dropdownMenu-col flex-column align-items-center">
        <div className="ball-col" value={ball.id} onClick={() => this.props.ballIncrement(ball.id, breakNumber, frameNumber, player)}>
          {count !== 0 && <div className="num-count">{count}</div>}
          <img src={ball.imgSrc} alt={`Ball ${ball.id}`} />
        </div>
        <div className="add-min d-flex">
          <a onClick={() => this.props.ballIncrement(ball.id, breakNumber, frameNumber, player)}
            id="increment">
            <svg viewBox="0 0 32 32">
              <g data-name="Layer 2" id="Layer_2">
                <path d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z" />
                <path d="M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z" />
                <path d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z" />
              </g>
              <g id="frame">
                <rect class="cls-1" fill="none" height="32" width="32" />
              </g>
            </svg>
          </a>
          <a
            onClick={() => this.props.ballDecrement(ball.id, breakNumber, frameNumber, player)}
            id="decrement">
            <svg viewBox="0 0 32 32">
              <g data-name="Layer 2" id="Layer_2">
                <path d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z" />
                <path d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z" />
              </g>
              <g id="frame">
                <rect class="cls-1" fill="none" height="32" width="32" />
              </g>
            </svg>
          </a>
        </div>
      </div >
    );
  }
}

export default Ball;